// src/pages/Announcement1.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./HRAnnouncementPage.css";
import apiClient from "../utils/apiClient";
import SessionHandler from "../components/SessionHandler";

const Announcement1 = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedAnnouncementId, setSelectedAnnouncementId] = useState(null);

  // ✅ result popup
  const [showResultPopup, setShowResultPopup] = useState(false);
  const [resultMessage, setResultMessage] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    fetchAnnouncements();
  }, []);

  const fetchAnnouncements = async () => {
    try {
      const data = await apiClient("/announcements/");
      if (!data) return;

      if (Array.isArray(data.results)) {
        setAnnouncements(data.results);
      } else if (Array.isArray(data)) {
        setAnnouncements(data);
      } else if (Array.isArray(data.announcements)) {
        setAnnouncements(data.announcements);
      }
    } catch (error) {
      console.error("Error fetching announcements:", error);
    }
  };

  const handleView = (announcement) => {
    navigate(`/dashboard/announcements/view/${announcement.id}`, {
      state: {
        title: announcement.title,
        date: new Date(announcement.valid_upto).toLocaleDateString(),
        details: announcement.message,
      },
    });
  };

  /* ================= DELETE ================= */

  const handleDeleteClick = (id) => {
    setSelectedAnnouncementId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    const id = selectedAnnouncementId;
    if (!id) return;

    try {
      await apiClient(`/announcements/${id}/`, {
        method: "DELETE",
      });

      // ✅ INSTANT UI REFRESH (NO API CALL NEEDED)
      setAnnouncements((prev) =>
        prev.filter((a) => a.id !== id)
      );

      setResultMessage("Announcement deleted successfully.");
      setShowResultPopup(true);
    } catch (error) {
      console.error("Error deleting announcement:", error);
      setResultMessage("Failed to delete announcement.");
      setShowResultPopup(true);
    } finally {
      setShowDeleteModal(false);
      setSelectedAnnouncementId(null);
    }
  };

  const cancelDelete = () => {
    setShowDeleteModal(false);
    setSelectedAnnouncementId(null);
  };

  const handleAdd = () => {
    navigate("/dashboard/ManagerAcess/createannouncementPage");
  };

  return (
    <div className="announcement1-page">
      <div className="page-header">
        <h1 className="page-title">Announcements</h1>
        <button className="add-btn" onClick={handleAdd}>
          +
        </button>
      </div>

      <table className="announcement1-table">
        <thead>
          <tr>
            <th>Sr.no</th>
            <th>Title</th>
            <th>Date</th>
            <th>View</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {announcements.length > 0 ? (
            announcements.map((announcement, index) => (
              <tr key={announcement.id}>
                <td>{index + 1}</td>
                <td>{announcement.title}</td>
                <td>
                  {new Date(announcement.valid_upto).toLocaleDateString()}
                </td>
                <td>
                  <button
                    className="view-btn"
                    onClick={() => handleView(announcement)}
                  >
                    View
                  </button>
                </td>
                <td>
                  <button
                    className="delete-btn"
                    onClick={() =>
                      handleDeleteClick(announcement.id)
                    }
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" style={{ textAlign: "center" }}>
                No announcements found.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* DELETE CONFIRM MODAL */}
      {showDeleteModal && (
        <div className="modal26-overlay">
          <div className="modal26-container">
            <h3>Confirm Deletion</h3>
            <p>Are you sure you want to delete this announcement?</p>
            <div className="modal26-actions">
              <button
                className="confirm-btn26"
                onClick={confirmDelete}
              >
                Yes, Delete
              </button>
              <button
                className="cancel-btn26"
                onClick={cancelDelete}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* RESULT POPUP */}
      {showResultPopup && (
        <div className="modal26-overlay">
          <div className="modal26-container">
            <p>{resultMessage}</p>
            <button
              className="confirm-btn26"
              onClick={() => setShowResultPopup(false)}
            >
              OK
            </button>
          </div>
        </div>
      )}

      <SessionHandler />
    </div>
  );
};

export default Announcement1;
